// Central shared width constant for Multiplayer Results UI
// Use this to keep all cards and action buttons the same width for visual alignment

export const RESULTS_SHARED_WIDTH = 360; // px, adjust as needed for widest element
